import { Component, ElementRef, OnInit, ViewChild, signal} from '@angular/core';
import { RouterLink } from '@angular/router';
import { NavMenu } from '../nav-menu/nav-menu';

@Component({
  selector: 'app-home',
  templateUrl: './home.html',
  styleUrls: ['./home.css'],
  imports: [NavMenu, RouterLink],
})
export class Home implements OnInit {
  openItem = signal<number | null>(null);

  toggleAccordion(item: number): void {
    this.openItem.update(current =>
      current === item ? null : item
    );  
  }
 
  ngOnInit() {
    window.scrollTo(0, 0);

  }

  //tickTock() {
  //  this.date = new Date();
  //  this.now = this.date.getTime();
  //  this.days.nativeElement.innerText = Math.floor(this.difference);
  //  this.hours.nativeElement.innerText = 23 - this.date.getHours();
  //  this.minutes.nativeElement.innerText = 60 - this.date.getMinutes();
  //  this.seconds.nativeElement.innerText = 60 - this.date.getSeconds();
  //}
}
